import { ArrowRight } from 'lucide-react';

/**
 * "Start here · everyone qualifies" welcome-survey banner — the guaranteed
 * first-win card. Presentational + reusable: the SINGLE shared visual rendered
 * on both /surveys and the dashboard (B2). Each host owns the eligibility query
 * (['welcome-survey']) and the WelcomeSurveyModal; this component is only the
 * card, so there is no forked second copy.
 */
export default function WelcomeSurveyBanner({ points, onStart }: { points: number; onStart: () => void }) {
  return (
    <button
      onClick={onStart}
      data-testid="welcome-survey-card"
      className="w-full text-left rounded-2xl bg-gradient-to-r from-[#10B981] to-[#059669] text-white p-5 shadow-sm hover:shadow-md transition-all flex items-center justify-between gap-3"
    >
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-white/80">Start here · everyone qualifies</p>
        <p className="text-base font-bold mt-0.5">Your welcome bonus is guaranteed</p>
        <p className="text-xs text-white/90 mt-1">~3 min · helps us match you · <span className="font-semibold">+{points} pts</span></p>
      </div>
      <span className="flex items-center gap-1 bg-white/20 rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap">
        Start <ArrowRight className="w-4 h-4" />
      </span>
    </button>
  );
}
